import { queryOptions } from "@tanstack/react-query";

import { SportEventsNewQueryKeys } from "./sportEventsNewQueryKeys";
import { getSportEventsCount, SportType } from "@/api/sportEventsNew";

import { FeedType } from "@/types/SportsApiResponses";
import { getRefetchIntervalByFeedType } from "@/utils/sportEvents";

export interface SportEventsCountParams {
  locale: string;
  feedType: FeedType;
  sportType: SportType;
}

// Query options for a single sport's total match count. Designed to be mapped
// over the sports list with `useQueries`, so every tab (football, basketball,
// ...) can show its count — not just the active one whose full list is loaded.
export const createSportEventsCountQueryOptions = ({
  locale,
  feedType,
  sportType,
}: SportEventsCountParams) =>
  queryOptions({
    queryKey: [SportEventsNewQueryKeys.Count, locale, feedType, sportType],
    refetchInterval: getRefetchIntervalByFeedType(feedType),
    queryFn: ({ signal }) =>
      getSportEventsCount({
        signal,
        params: {
          lang: locale,
          feedType,
          sportType,
          page: 1,
          pageSize: 1,
          excludeMarkets: true,
        },
      }),
  });
